module.exports = __webpack_public_path__ + "static/img/step5_tc@2x.7c06cd8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/howtobuy/step5_tc@2x.jpg
// module id = 550
// module chunks = 0